import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { bulkUpsertContacts, createContact, getContact, mergeContacts, queryContacts, searchContacts, upsertContact } from '@wix/ambassador-contacts-v4-contact/http';
import { getOrCreateConversation } from '@wix/ambassador-crm-inbox-v2-conversation/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { ContactClientBase } from './ContactClientBase';
export class ContactClient extends HttpBaseClient(ContactClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createContactImpl", createContact);
    _defineProperty(this, "getContactImpl", getContact);
    _defineProperty(this, "queryContactsImpl", queryContacts);
    _defineProperty(this, "searchContactsImpl", searchContacts);
    _defineProperty(this, "getInboxConversationIdImpl", getOrCreateConversation);
    _defineProperty(this, "bulkUpsertContactsImpl", bulkUpsertContacts);
    _defineProperty(this, "upsertContactImpl", upsertContact);
    _defineProperty(this, "mergeContactsImpl", mergeContacts);
  }
}
//# sourceMappingURL=ContactClientHttp.js.map